
const API_URL = process.env.VUE_APP_API_URL;

export function imgToSmallSrc (filename) {
  if (filename === undefined) {
    return 'img/invest_park_logo_big.png';
  }
  return `${API_URL}/pliki/get/400px/${filename}`;
}
